(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  // --- Section : Gallery
  if (typeof Gallery !== 'function') {
    class Gallery extends HTMLElement {
      constructor(){
        super();

        this.GallerySwiper = null;
        this.modal = this.nextElementSibling;
        this.init();
      }

      init() {
        const self = this;
        let itemsButton = this.querySelectorAll('.flex-caption.fullscreen');

        if(itemsButton) {
          itemsButton.forEach((button) => {
            button.addEventListener('click', (e) => {
              if(self.GallerySwiper == null){
                self.createSwiper(parseInt(button.closest('.swiper-slide').dataset.index));
              }
            });
          })
        }
      }

      createSwiper(slideToIndex) {
        const modalContent = this.modal.querySelector('.gallery-media-modal__content');
        modalContent.innerHTML = "";
        modalContent.appendChild(this.querySelector('.swiper-gallery-container').cloneNode(true));
        modalContent.querySelector('.swiper').dataset.shown = 1;
        modalContent.querySelectorAll('.image-container').forEach((image) => {
          image.setAttribute('class', 'image-container')
          image.querySelector('img') && image.querySelector('img').setAttribute('sizes', '100vw')
        });

        this.GallerySwiper = modalContent.querySelector('.swiper').swiper;
        modalContent.querySelector('.swiper').swiper.slideTo(slideToIndex)
      }
    }
    customElements.define('gallery-fullsize', Gallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-line"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#shopify-header-section');
      this.announce_bar = document.querySelector('#shopify-section-announce-bar');
      this.menu_section = document.querySelector('.menu-section');
      this.headerBounds = {};

      this.getStickyType();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 780px)').addEventListener('change', this.getStickyType.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    getStickyType () {
      this.headerIsAlwaysSticky = document.documentElement.clientWidth > 780 ? this.getAttribute('data-sticky-type') === 'sticky' : this.getAttribute('data-sticky-type-mob') === 'sticky';
    }

    setHeaderHeight() {
      this.height =  this.header.offsetHeight + (this.header.classList.contains('header__overlay') ? this.menu_section.offsetHeight : 0)

      document.documentElement.style.setProperty('--header-height', `${this.height}px`)

      if(this.announce_bar){
        document.documentElement.style.setProperty('--announce-bar-height', `${this.announce_bar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-lines"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#shopify-header-section');
      this.announce_bar = document.querySelector('#shopify-section-announce-bar');
      this.menu_section = document.querySelector('.menu-section');
      this.headerBounds = {};

      this.getStickyType();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 780px)').addEventListener('change', this.getStickyType.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    getStickyType() {
      this.headerIsAlwaysSticky = document.documentElement.clientWidth > 780
        ? this.getAttribute('data-sticky-type') === 'sticky'
        : this.getAttribute('data-sticky-type-mob') === 'sticky';
    }

    setHeaderHeight() {
      this.height = this.header.offsetHeight + (
        this.header.classList.contains('header__overlay')
          ? this.menu_section.offsetHeight
          : 0
      )

      document.documentElement.style.setProperty('--header-height', `${
        this.height
      }px`)

      if (this.announce_bar) {
        document.documentElement.style.setProperty('--announce-bar-height', `${
          this.announce_bar.offsetHeight
        }px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-sidebar"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('#shopify-header-section');
    this.announce_bar = document.querySelector('#shopify-section-announce-bar');
    this.menu_section = document.querySelector('.menu-section');
    this.headerBounds = {};

    this.getStickyType();
    this.setHeaderHeight();

    window.matchMedia('(max-width: 780px)').addEventListener('change', this.getStickyType.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  getStickyType () {
    this.headerIsAlwaysSticky = document.documentElement.clientWidth > 780 ? this.getAttribute('data-sticky-type') === 'sticky' : this.getAttribute('data-sticky-type-mob') === 'sticky';
  }

  setHeaderHeight() {
    this.height =  this.header.offsetHeight + (this.header.classList.contains('header__overlay') ? this.menu_section.offsetHeight : 0)

    document.documentElement.style.setProperty('--header-height', `${this.height}px`)

    if(this.announce_bar){
      document.documentElement.style.setProperty('--announce-bar-height', `${this.announce_bar.offsetHeight}px`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  if (typeof Summary !== 'function'){
    class Summary extends HTMLElement {
      constructor(){
        super();
      }

      connectedCallback() {
        const h = this.dataset.hn,
              content = this.closest('article').querySelector('.article-content'),
              summary = this.querySelector('.summary'); 
        let nb_titles = 0;

        for(i = 2; i <= h; i++){
          const titles = content.querySelectorAll("h" + i);
          nb_titles += titles.length;
        }

        if (nb_titles >= this.dataset.limit) {
          var ul = document.createElement('ul');

          if(summary.nodeName == "LINK-COLLAPSING"){
            ul.classList.add("link_collapsing_content");
            ul.style.display = "none";
          }

          ul.innerHtml = "";
          summary.appendChild(ul);
          var toc = "";
          var start = 4;
          var children = content.children;

          for (var i = 0; i < children.length; i++) {
            if(children[i].nodeName.match(/^H\d+$/)){
              var level = children[i].nodeName.substr(1);
              if(level <= h){

                // Correction ancrage directement sur le H2, H3
                var headerText = children[i].textContent;
                var anchor = "toc-" + i;
                
                children[i].setAttribute("id", anchor);
                
                /*
                var headerText = (children[i].textContent);
                var anchor = "toc-" + i;

                var tag = '<a href="#' + anchor + '" id="' + anchor + '">' + headerText + '</a>';

                children[i].innerHTML = tag;*/

                if(headerText){
                    if (level > start) {
                      toc += (new Array(level - start + 1)).join('<ul>');
                    } else if (level < start) {
                      toc += (new Array(start - level + 1)).join('</li></ul>');
                    } else {
                      toc += (new Array(start+ 1)).join('</li>');
                    }
                    start = parseInt(level);
                    toc += '<li><a href="#' + anchor + '">' + headerText + '</a>';
                }
              }
            }
          }

          if (start) {
            toc += (new Array(start + 1)).join('</ul>');
          }

          ul.innerHTML += toc;
          summary.querySelector(".link_collapsing_title").style.opacity = "";
          summary.classList.remove('loading-gradient');
        } else {
          summary.classList.add('hide');
          return;
        }

        ul.querySelectorAll("a[href*='#']:not([href='#'])").forEach((link) => {
          link.addEventListener("click", function(event) {
            event.preventDefault();
            if (
              location.hostname == this.hostname &&
              this.pathname.replace(/^\//, "") == location.pathname.replace(/^\//, "")
            ) {
              var anchor = this.hash;
              anchor = anchor.length ? anchor : content.querySelector("[name=" + this.hash.slice(1) + "]");
              if (anchor) {
                var targetElement = document.querySelector(anchor);
                var rect = targetElement.getBoundingClientRect();


                /*var offsetTop = rect.top + window.pageYOffset - parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));*/
                //Correction problème scroll ancrage
                var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
                var offsetTop = rect.top + window.pageYOffset - headerHeight;
                window.scrollTo({ top: offsetTop, behavior: "smooth" });
              }
            }
          });
        });
      }
    }
    customElements.define('article-summary', Summary)
  }

  if (typeof ProgressBar !== 'function'){
    class ProgressBar extends HTMLElement {
      constructor(){
        super();

        var self = this;
        this.namespace = '.progress-bar';
        self.dataScroll = document.querySelector('.header').getAttribute('data-scroll');
        self.dataScrollMob = document.querySelector('.header').getAttribute('data-scroll-mob');

        this.bindEvents();

        document.addEventListener('shopify:section:load', function(){
          self.bindEvents();
        });

        window.on('resize'+ this.namespace, theme.utils.debounce(300, function() {
          self.bindEvents();
          setTimeout(function(){ 
            if(((self.dataScroll != "none" && document.documentElement.clientWidth >= 780) || (self.dataScrollMob != "none" && document.documentElement.clientWidth < 780)) && document.documentElement.clientHeight + 200 < document.body.getBoundingClientRect().height){
              self.scroll = document.documentElement.clientWidth >= 780 ? self.dataScroll : self.dataScrollMob;
              if((document.body.classList.contains('header__sticky') && self.scroll == "sticky") || (document.body.classList.contains('header__sticky') && document.body.classList.contains('scroll_up') && self.scroll == "up")) {
                self.style.transform = 'translateY('+ document.querySelector('.header').getBoundingClientRect().height + 'px)';
      
                self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
                  sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + self.getBoundingClientRect().height + 20 + "px"
                });
              } else {
                self.style.transform = '';
      
                self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
                  sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + 20 + "px"
                });
              }
            }
          }, 0.1)
        }));
      }

      bindEvents(){
        var self = this;
        window.addEventListener("scroll", theme.utils.debounce(10, function(){ self.onScroll() }))
      }

      onScroll(){
        var self = this;
        setTimeout(function(){
          if(((self.dataScroll != "none" && document.documentElement.clientWidth >= 780) || (self.dataScrollMob != "none" && document.documentElement.clientWidth < 780)) && document.documentElement.clientHeight + 200 < document.body.getBoundingClientRect().height){
            self.scroll = document.documentElement.clientWidth >= 780 ? self.dataScroll : self.dataScrollMob;
            if((document.body.classList.contains('header__sticky') && self.scroll == "sticky") || (document.body.classList.contains('header__sticky') && document.body.classList.contains('scroll_up') && self.scroll == "up")) {
              self.style.transform = 'translateY('+ document.querySelector('.header').getBoundingClientRect().height + 'px)';

              self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
                sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + self.getBoundingClientRect().height + 20 + "px"
              });
            } else {
              self.style.transform = '';

              self.closest('.section-container').querySelectorAll('.position--sticky').forEach((sticky) => {
                sticky.style.top = document.querySelector('.header').getBoundingClientRect().height + 20 + "px"
              });
            }
          }
        }, 0.1)

        var articleTop = document.querySelector('.header').getBoundingClientRect().height + 250
          , articleBottom = document.querySelector("article.article-container").offsetTop + document.querySelector("article.article-container").getBoundingClientRect().height;
        articleTop + .7 * articleTop < window.scrollY && articleBottom - 200 > window.scrollY ? this.setAttribute("aria-hidden", "false") : this.setAttribute("aria-hidden", "true");

        var i = this.getBoundingClientRect(),
        r = document.querySelector("article.article-container").getBoundingClientRect(),
        a = r.bottom - i.bottom,
        o = Math.abs(a / r.height - 1);
        this.querySelector('.article__progress-bar').style.width = 100 * o + "%"
      }
    }
    customElements.define('progress-bar', ProgressBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-order-tracker"]) return;
  try {
    
  class TrackingNumber extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      if(this.classList.contains('tracking-more')){
          const form = this.querySelector('form');
          if(form.querySelector('[name="button_tracking_number"]').value != ''){
            window.open('_blank').location = `${form.getAttribute('action')}/${form.querySelector('[name="button_tracking_number"]').value}?express=${form.querySelector('[name="express_code"]').value}&lang=${form.querySelector('[name="lang"]').value}`
          } else {
            form.addEventListener('submit', function(e){
              e.preventDefault();
              e.stopPropagation();
              window.open('_blank').location = `${form.getAttribute('action')}/${form.querySelector('[name="button_tracking_number"]').value}?express=${form.querySelector('[name="express_code"]').value}&lang=${form.querySelector('[name="lang"]').value}`
            });
          }
        }
    }
  }
  customElements.define('tracking-number', Tracking);

  class TrackingGenie extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      var self = this;

      var options = {
        minDays: parseInt(this.getAttribute('data-min-days')),
        maxDays: parseInt(this.getAttribute('data-max-days')),
        preparation: this.getAttribute('data-preparation'),
        text_preparation: this.getAttribute('data-text-preparation'),
        bg_preparation: this.getAttribute('data-bg-preparation'),
        on_way: this.getAttribute('data-on-way'),
        text_on_way: this.getAttribute('data-text-on-way'),
        bg_on_way: this.getAttribute('data-bg-on-way'),
        late: this.getAttribute('data-late'),
        text_late: this.getAttribute('data-text-late'),
        bg_late: this.getAttribute('data-bg-late'),
        submit: this.querySelector('button[type="submit"]'),
        formError: this.querySelector('#track-error'),
        loadingBar: this.querySelector('.loading-bar'),
        statusTitle: this.querySelector('.status span'),
        statusText: this.querySelector('.text-status'),
        firstDateText: this.querySelector('#firstDate'),
        lastDateText: this.querySelector('#lastDate')
      };

      options.submit.addEventListener("click", function(){
        if(self.querySelector('input[type="text"]').value.trim == '' || !self.querySelector('input[type="date"]').value){
          options.formError.show();
        } else {
          var inputDate = self.querySelector('input[type="date"]').value;
          var inputDateFormat = new Date(inputDate);
          var dayNow = new Date();

          if (inputDateFormat > dayNow) { return; }

          inputDate = inputDate.replace(/-/g, ',');
          var today = new Date(),
          dd = String(today.getDate()).padStart(2, '0'),
          mm = String(today.getMonth() + 1).padStart(2, '0'),
          yyyy = today.getFullYear();
          today = yyyy + ',' + mm + ',' + dd;

          var oneDay = 24*60*60*1000,
          firstDate = new Date(inputDate),
          secondDate = new Date(today),
          diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));

          function getDeliveryDates(averageNumber) {
            var averageDeliveryTimeMin = options.minDays + options.maxDays - 5,
            averageDeliveryTimeMax = options.minDays + options.maxDays + averageNumber,
            minDeliveryDate = self.addDays(inputDateFormat, averageDeliveryTimeMin),
            maxDeliveryDate = self.addDays(inputDateFormat, averageDeliveryTimeMax),
            minDay = minDeliveryDate.getDate(),
            minMonth = minDeliveryDate.getMonth() + 1,
            minYear = minDeliveryDate.getFullYear(),
            maxDay = maxDeliveryDate.getDate(),
            maxMonth = maxDeliveryDate.getMonth() + 1,
            maxYear = maxDeliveryDate.getFullYear();

            if (minDay < 10) { minDay = '0' + minDay; }
            if (minMonth < 10) { minMonth = '0' + minMonth; } 
            if (maxDay < 10) { maxDay = '0' + maxDay; } 
            if (maxMonth < 10) { maxMonth = '0' + maxMonth; }
            
            options.firstDateText.innerHTML = minDay + '/' + minMonth + '/' + minYear;
            options.lastDateText.innerHTML = maxDay + '/' + maxMonth + '/' + maxYear;
            self.querySelector('.tracking').style.display = '';
          }

          if(diffDays < options.minDays ) {
            options.loadingBar.classList.add('loading-bar-grey');
            options.loadingBar.style.background = options.bg_preparation;
            options.statusTitle.innerHTML = options.preparation;
            options.statusText.innerHTML = options.text_preparation;
            getDeliveryDates(5);
          } else if(diffDays >= options.minDays && diffDays < options.maxDays) {
            options.loadingBar.classList.remove('loading-bar-grey');
            options.loadingBar.style.background = options.bg_on_way;
            options.statusTitle.innerHTML = options.on_way;
            options.statusText.innerHTML = options.text_on_way;
            getDeliveryDates(5);
          } else {
            options.loadingBar.classList.remove('loading-bar-grey');
            options.loadingBar.style.background = options.bg_late;
            options.statusTitle.innerHTML = options.late;
            options.statusText.innerHTML = options.text_late;
            getDeliveryDates(10);
          }
        }
      });
    }

    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
  }
  customElements.define('tracking-genie', TrackingGenie);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  /* --- Section Search */
  class SearchForm extends HTMLElement {
    constructor(){
      super();
    }

    connectedCallback(){
      var self = this;

      this.querySelector('form').addEventListener('submit', function(e){
        e.preventDefault();
        e.stopPropagation();
      });

      this.querySelector('input').addEventListener('input',
      theme.utils.throttle(function(){
        setTimeout(function(){
          self.getSearch()
        }, 300)
      },300));
    }

    getSearch(){
      const pagination = this.closest('section').querySelector('.collection_pagination');
      const resultsText = this.closest('section').querySelector('.search_results');
      const resultsGrid = this.closest('section').querySelector('#productsGrid');
      const resultsContent = this.closest('section').querySelector('#productsGrid');

      resultsGrid.classList.add('loading');
      resultsContent.innerHTML = '';

      let form = this.querySelector('form');
      const formSerialize = JSON.parse(theme.utils.serializeForm(form));

      fetch(form.getAttribute('action') + '?q='+ formSerialize.q + '&options%5Bprefix%5D=last',
        { ...theme.utils.fetchConfig('javascript') })
        .then(response => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const Source_pagination = html.querySelector('.collection_pagination');
          const Source_resultsText = html.querySelector('.search_results');
          const Source_resultsContent = html.querySelector('#productsGrid');

          if (Source_pagination && pagination) pagination.innerHTML = Source_pagination.innerHTML;
          if (Source_resultsText && resultsText) resultsText.innerHTML = Source_resultsText.innerHTML;
          if (Source_resultsContent && resultsContent) resultsContent.innerHTML = Source_resultsContent.innerHTML;

          resultsGrid.querySelectorAll('img', 'svg').forEach((lazyBackground) => {
            theme.utils.lazyBackgroundObserver.observe(lazyBackground);
          });

          resultsGrid.classList.remove('loading');
          resultsGrid.classList.remove('hide');
        })
    }
  }
  customElements.define('search-form', SearchForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map"] && !Shopify.designMode) return;
  try {
    
  if(typeof Map !== "function"){
    // --- Section : Map
    class Map extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        this.settings = {
          apiKey: this.getAttribute('data-api-key'),
          address: this.getAttribute('data-address'),
          mapStyle: this.getAttribute('data-map-style'),
          enablePin: this.getAttribute('data-enable-pin') == "true" ? true : false,
          markerColor: this.getAttribute('data-marker-color')
        };

        this.map;

        this.init();
      }

      init(){
        const self = this;
        this.map = null;
        if (typeof this.settings.apiKey !== 'string' || this.settings.apiKey === '') {
          return;
        }

        if (typeof window.google === 'undefined') {
          theme.utils.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.settings.apiKey
          ).then(function(){
            self.createMap();
          });
        } else {
          self.createMap();
        }
      }

      createMap() {
        const self = this;
        new Promise(function(resolve, reject) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: self.settings.address }, function(results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
              reject(status);
            } else {
              resolve(results);
            }
          });
        }).then(function(results){
          var style = JSON.parse(self.settings.mapStyle);

          var config = {
            zoom: 14,
            styles: style
          };

          var mapOptions = {
            zoom: config.zoom,
            styles: config.styles,
            center: results[0].geometry.location,
            draggable: true,
            clickableIcons: true,
            scrollwheel: true,
            disableDoubleClickZoom: false,
            disableDefaultUI: false
          }; 

          self.map = new google.maps.Map(this, mapOptions);
          var enablePin = self.settings.enablePin;
          var markerColor = self.settings.markerColor;
          var center = self.map.getCenter();

          var markerIcon = {
            path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
            fillColor: markerColor,
            fillOpacity: 0.9,
            scale: 1.5,
            strokeWeight: 0
          };

          //eslint-disable-next-line no-unused-vars
          if(enablePin){
            new google.maps.Marker({
              map : self.map,
              icon: markerIcon,
              position: center
            });
          }

          google.maps.event.addDomListener(window, 'resize',
            theme.utils.debounce(250,function() {
              google.maps.event.trigger(self.map, 'resize');
              self.map.setCenter(center);
            })
          );
        }).catch(function(status){
          var errorMessage;
          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break; 
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var mapContainer = self.closest('.map-section');
            mapContainer.classList.add('map-section--load-error');
            mapContainer.querySelector('.map-error__wrapper').innerHTML = '<div class="errors text-center" style="width: 100%;">' +  errorMessage + '</div>';
          }
        });
      }

      onUnload(){
        if (typeof window.google !== 'undefined' && this.map != null) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    }
    customElements.define('map-js', Map);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-age-verification"] && !Shopify.designMode) return;
  try {
    
  if(typeof PopupAge !== 'function'){
    class PopupAge extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        const modal = this.querySelector('modal-dialog'),
              test = this.dataset.test == "true" ? true : false;

          if(!test) {
            if (typeof Storage !== "undefined" && (sessionStorage.verification_age && JSON.parse(sessionStorage.verification_age) != 1) || typeof sessionStorage.verification_age === "undefined") {
              modal.show(this, !1);
            } else {
              return;
            }

            modal.querySelector('button').addEventListener("click", function(){
              sessionStorage.verification_age = JSON.stringify(1);
              modal.hide();
            });
          } else {
            modal.show(this, !1);
            modal.querySelector('button').addEventListener("click", function(){
              modal.hide();
            });
          }
      }
    }

    customElements.define('popup-age', PopupAge);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-orders-notif"] && !Shopify.designMode) return;
  try {
    
  if(typeof OrdersNotif !== 'function'){
    // snippet: popup-orders-notif
    class OrdersNotif extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        var self = this;
        this.test = this.getAttribute('data-test') == "true" ? true : false;
        this.delay = this.test ? 0 : parseInt(this.getAttribute('data-delay'));

        this.x = setInterval(function() {
          var randomNotificationNumber = Math.floor((Math.random() * 29) + 1),
            randomProductNumber = Math.floor((Math.random() * 8) + 1),
            citiesArray = Shopify.theme_settings.popup_orders_notifs_city,
            randomIndexCity = Math.floor(Math.random() * citiesArray.length),
            randomCity = citiesArray[randomIndexCity];

            let product = self.querySelector('.popup-orders-notif-content:nth-child('+randomProductNumber+')');
            if(self.querySelector('.popup-orders-notif-content:not(.hide)')) {
              self.querySelector('.popup-orders-notif-content:not(.hide)').classList.add('hide');
            }

            self.classList.remove('fadeOut'),
            product.classList.remove('hide'),
            product.querySelector('.popup-orders-notif__random-city').innerText = randomCity,
            product.querySelector('.popup-orders-notif__time').innerText = randomNotificationNumber;

            if(!self.test){
              setTimeout(function() {
                self.classList.add('fadeOut');
              }, 4000);
            } else {
              clearInterval(self.x);
            }
        }, self.delay * 1e3);

        this.querySelectorAll('.popup-orders-notif-content').forEach( (product) => {
          product.addEventListener('click', function(){
            window.location.href= this.getAttribute('data-href');
          })
        });

        this.querySelector('.modal__close').addEventListener('click', function(){
          self.close();
        });
      }

      close(){
        if(this.x) clearInterval(this.x);
        this.container.classList.add('hide');
      }
    }
    customElements.define('popup-orders', OrdersNotif);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-rgpd-cookies"] && !Shopify.designMode) return;
  try {
    
  // -- Popup RGPD
  if(typeof RGPD !== 'function'){
    class RGPD extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        this.rgpd_banner_container = this.querySelector('modal-dialog');
        this.rgpd_banner = this.rgpd_banner_container.querySelector('.rgpd-cookiebanner');
        this.rgpd_consent_stored_once = !1;
        this.rgpd_categories = ["functional", "preferences", "statistics", "marketing"];
        this.rgpd_user_data = [];
        this.rgpdData = {
          test_mode: this.dataset.test,
          dismiss_on_scroll: 0,
          set_cookies: [],
          cookie_expiry: 365
        };
    
        var self = this;
    
        document.addEventListener('consentCustomer', () => {
          self._conditionally_show_banner();
    
          if (typeof Storage !== "undefined" && sessionStorage.rgpd_user_data) {
            self.rgpd_user_data = JSON.parse(sessionStorage.rgpd_user_data)
          }
      
          var rgpd_id_cookie = theme.Cookies.get("id");
          var rgpd_id_session = "";
          var rgpd_id = "";
          if (typeof Storage !== "undefined" && sessionStorage.rgpd_id) {
            rgpd_id_session = JSON.parse(sessionStorage.rgpd_id)
          }
      
          if (rgpd_id_cookie.length == 0 && rgpd_id_session.length > 0) {
            rgpd_id = rgpd_id_session;
            theme.Cookies.set("rgpd_id", rgpd_id, self.rgpdData.cookie_expiry);
          }
          if (rgpd_id_cookie.length > 0 && rgpd_id_session.length == 0) {
            rgpd_id = rgpd_id_cookie
          }
          if (typeof Storage !== "undefined") {
            sessionStorage.rgpd_id = JSON.stringify(rgpd_id)
          }
        });      
      }

      _rgpd_create_element(el, content) {
        let obj = document.createElement(el);
        obj.innerHtml = content;
        return obj
      }

      _rgpd_add_event(event, selector, callback) {
        document.addEventListener(event, e => {
          if (e.target.closest(selector)) {
            callback(e)
          }
        });
      }

      _rgpd_is_hidden(el) {
        return el.offsetParent === null
      }
      
      _rgpd_html_decode(input) {
        var doc = (new DOMParser).parseFromString(input, "text/html");
        return doc.documentElement.textContent
      }

      _rgpd_set_category_as_body_class() {
        let classList = document.body.className.split(/\s+/);
        for (let i = 0; i < classList.length; i++) {
          if (classList[i].indexOf("rgpd-") !== -1 && classList[i] !== "rgpd-document") {
            document.body.classList.remove(classList[i])
          }
        }
        let cats = this._rgpd_accepted_categories();
        for (let i in cats) {
          if (cats.hasOwnProperty(i)) {
            document.body.classList.add("rgpd-" + cats[i])
          }
        }
        let services = this._rgpd_get_all_service_consents();
        for (let service in services) {
          if (services.hasOwnProperty(service) && services[service]) {
            document.body.classList.add("rgpd-" + service)
          }
        }
      }

      _rgpd_enable_category(category, service) {
        service = typeof service !== "undefined" ? service : "do_not_match";
        if (category === "")
          category = "do_not_match";
        if (category === "functional") {
          return
        }
        if (category === "marketing") {
          this._rgpd_set_integrations_cookies()
        }
        document.querySelectorAll(".rgpd-blocked-content-notice.rgpd-accept-" + category + ", .rgpd-blocked-content-notice[data-service=" + service + "]").forEach(obj => {
          obj.parentNode.removeChild(obj)
        });
      
        document.querySelectorAll("[data-category=" + category + "], [data-service=" + service + "]").forEach(obj => {
          let elementService = obj.getAttribute("data-service");
          if (rgpd_is_service_denied(elementService)) {
            return
          }
          if (obj.getAttribute("data-category") === "functional") {
            return
          }
          obj.classList.add("rgpd-activated")
        });
      }
      
      _rgpd_array_is_empty(arr) {
        for (let key in arr) {
          if (arr.hasOwnProperty(key)) {
            return !1
          }
        }
        return !0
      }
      
      _rgpd_get_services_on_page() {
        let services = [];
        document.querySelectorAll("[data-service]").forEach(obj => {
          let service = obj.getAttribute("data-service");
          if (services.indexOf(service) == -1) {
            services.push(service)
          }
        });
        return services
      }
      
      _rgpd_is_bot() {
        var botPattern = "(googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
        var reBot = new RegExp(botPattern, "i");
        var userAgent = navigator.userAgent;
        if (reBot.test(userAgent)) {
          return !0
        } else {
          return !1
        }
      }
      
      _rgpd_is_speedbot() {
        var userAgent = navigator.userAgent;
        var speedBotPattern = "(GTmetrix|pingdom|pingbot|Lighthouse)";
        var speedBot = new RegExp(speedBotPattern, "i");
        if (speedBot.test(userAgent)) {
          return !0
        } else {
          return !1
        }
      }
      
      _rgpd_exists_service_consent() {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services;
        try {
          consented_services = JSON.parse(consented_services_json);
          for (const key in consented_services) {
            if (consented_services.hasOwnProperty(key)) {
              if (consented_services[key] == !0) {
                return !0
              }
            }
          }
        } catch (e) {
          return !1
        }
        return !1
      }
      
      _rgpd_set_service_consent(service, consented) {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services;
        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }
        consented_services[service] = consented;
        theme.Cookies.set("rgpd_consented_services", JSON.stringify(consented_services), this.rgpdData.cookie_expiry);
      }
      
      _rgpd_clear_all_service_consents() {
        theme.Cookies.set("rgpd_consented_services", "", this.rgpdData.cookie_expiry);
      }
      
      _rgpd_get_all_service_consents() {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services;
        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }
        return consented_services
      }
      
      _rgpd_track_status_end() {
        if (!this.rgpd_consent_stored_once) {
          rgpd_track_status()
        }
      }

      _rgpd_track_status(status) {
        var cats = [];
        status = typeof status !== "undefined" ? status : !1;
        if (!status) {
          cats = this._rgpd_accepted_categories()
        } else {
          cats = [status]
        }
        this._rgpd_set_category_as_body_class();
        var saved_cats, saved_services;
        try {
          saved_cats = JSON.parse(theme.Cookies.get("saved_categories"))
        } catch (e) {
          saved_cats = {}
        }
        try {
          saved_services = JSON.parse(theme.Cookies.get("saved_services"))
        } catch (e) {
          saved_services = {}
        }
        var consented_services = this._rgpd_get_all_service_consents();
        if (this._rgpd_equals(saved_cats, cats) && this._rgpd_equals(saved_services, consented_services)) {
          return
        }

        theme.Cookies.set("rgpd_saved_categories", JSON.stringify(cats), this.rgpdData.cookie_expiry);
        theme.Cookies.set("rgpd_saved_services", JSON.stringify(consented_services), this.rgpdData.cookie_expiry);
        this.rgpd_consent_stored_once = !0;
      }
      
      _rgpd_accepted_categories() {
        var self = this;
        var consentedCategories = this.rgpd_categories;
        var consentedTemp = [];
        for (var key in consentedCategories) {
          if (consentedCategories.hasOwnProperty(key)) {
            var category = consentedCategories[key];
            if (this._rgpd_has_consent(category)) consentedTemp.push(category)
          }
        }
        consentedCategories = consentedCategories.filter(function (value, index, consentedCategories) {
          return self._rgpd_in_array(value, consentedTemp)
        });
        return consentedCategories
      }
      
      _rgpd_sync_category_checkboxes() {
        for (var key in this.rgpd_categories) {
          if (this.rgpd_categories.hasOwnProperty(key)) {
            var category = this.rgpd_categories[key];
            if (this._rgpd_has_consent(category) || category === "functional") {
              document.querySelectorAll("input.rgpd-" + category).forEach(obj => {
                obj.checked = !0
              })
            } else {
              document.querySelectorAll("input.rgpd-" + category).forEach(obj => {
                obj.checked = !1
              })
            }
          }
        }
      }
      
      _rgpd_merge_object(userdata, ajax_data) {
        var output = [];
        for (key in ajax_data) {
          if (ajax_data.hasOwnProperty(key))
            output[key] = ajax_data[key]
        }
        for (var key in userdata) {
          if (!ajax_data.hasOwnProperty(key) || typeof ajax_data[key] === "undefined") {
            if (userdata.hasOwnProperty(key))
              output[key] = userdata[key]
          }
        }
        return output
      }
      
      _rgpd_clear_all_rgpdData_cookies(cookie_part) {
        var foundCookie = !1;
        if (typeof document === "undefined") return foundCookie;

        var secure = ";secure";
        var date = new Date;
        date.setTime(date.getTime() - 24 * 60 * 60 * 1e3);
        var expires = ";expires=" + date.toGMTString();
        if (window.location.protocol !== "https:")
          secure = "";
        (function () {
          var cookies = document.cookie.split("; ");
          for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            var skip_last = d.length > 1;
            while (d.length > 0) {
              var cookieName = cookies[c].split(";")[0].split("=")[0];
              var p = location.pathname;
              p = p.replace(/^\/|\/$/g, "").split("/");
              if (cookieName.indexOf(cookie_part) !== -1) {
                foundCookie = !0;
                var cookieBase = encodeURIComponent(cookieName) + "=;SameSite=Lax" + secure + expires + ";domain=." + d.join(".") + ";path=";
                var cookieBaseDomain = encodeURIComponent(cookieName) + "=;SameSite=Lax" + secure + expires + ";domain=;path=";
                document.cookie = cookieBaseDomain + "/";
                document.cookie = cookieBase + "/";
                while (p.length > 0) {
                  var path = p.join("/");
                  if (path.length > 0) {
                    document.cookie = cookieBase + "/" + path;
                    document.cookie = cookieBaseDomain + "/" + path;
                    document.cookie = cookieBase + "/" + path + "/";
                    document.cookie = cookieBaseDomain + "/" + path + "/"
                  }
                  p.pop()
                }
              }
              d.shift();
              if (skip_last && d.length == 1)
                d.shift()
            }
          }
        })();
        return foundCookie
      }
      
      _rgpd_integrations_init() {
        var cookiesToSet = this.rgpdData.set_cookies;
        for (var key in cookiesToSet) {
          if (cookiesToSet.hasOwnProperty(key) && cookiesToSet[key][1] === "1")
            theme.Cookies.set("rgpd_" + key, cookiesToSet[key][1], this.rgpdData.cookie_expiry);
        }
      }
      
      _rgpd_integrations_revoke() {
        var cookiesToSet = this.rgpdData.set_cookies;
        for (var key in cookiesToSet) {
          if (cookiesToSet.hasOwnProperty(key)) {
            theme.Cookies.set("rgpd_" + key, cookiesToSet[key][1], this.rgpdData.cookie_expiry);
            if (cookiesToSet[key][1] == !1) this._rgpd_clear_all_rgpdData_cookies(key)
          }
        }
      }
      
      _rgpd_set_integrations_cookies() {
        var cookiesToSet = this.rgpdData.set_cookies;
        for (var key in cookiesToSet) {
          if (cookiesToSet.hasOwnProperty(key)) theme.Cookies.set("rgpd_" + key, cookiesToSet[key][0], this.rgpdData.cookie_expiry);
        }
      }
      
      _rgpd_wp_set_consent(type, value) {
        if (typeof wp_set_consent == "function") this._wp_set_consent(type, value)
      }
      
      _rgpd_equals(array_1, array_2) {
        if (!Array.isArray(array_1)) {
          array_1 = Object.keys(array_1);
          array_2 = Object.keys(array_2)
        }
        if (!array_1 || !array_2) return !1;
        if (array_1.length != array_2.length) return !1;
        for (var i = 0, l = array_1.length; i < l; i++) {
          if (array_1[i] instanceof Array && array_2[i] instanceof Array) {
            if (!rgpd_equals(array_1[i], array_2[i]))
              return !1
          } else if (array_1[i] != array_2[i])  return !1
        }
        return !0
      }

      _rgpd_in_array (needle, haystack) {
        let length = haystack.length;
        for (let i = 0; i < length; i++) {
          if (haystack[i] == needle) return !0
        }
        return !1
      }

      _rgpd_highest_accepted_category () {
        var consentedCategories = rgpd_accepted_categories();

        if (this._rgpd_in_array("marketing", consentedCategories)) {
          return "marketing" 
        }

        if (this._rgpd_in_array("statistics", consentedCategories)) {
          return "statistics"
        }
        
        if (this._rgpd_in_array("preferences", consentedCategories)) {
          return "preferences"
        }

        return "functional"
      }

      _rgpd_accept_all () {
        for (var key in this.rgpd_categories) {
          if (this.rgpd_categories.hasOwnProperty(key)) {
            this._rgpd_set_consent(this.rgpd_categories[key], "allow")
          }
        }
      }

      _conditionally_show_banner () {
        this._rgpd_set_consent("functional", "allow")
        let rev_cats = this.rgpd_categories.reverse();

        for (let key in rev_cats) {
          if (rev_cats.hasOwnProperty(key)) {
            let category = this.rgpd_categories[key];

            if (this._rgpd_has_consent(category)) {
              this._rgpd_enable_category(category)
            }
          }
        }

        if (this._rgpd_exists_service_consent()) {
          this._rgpd_enable_category("", "general");
          let services = this._rgpd_get_services_on_page();

          for (let key in services) {
            if (services.hasOwnProperty(key)) {
              let service = services[key];
    
              if (service.length == 0)
                continue;
              if (this._rgpd_has_service_consent(service)) {
                document.querySelectorAll(".rgpd-accept-service[data-service=" + service + "]").forEach(obj => {
                  obj.checked = !0
                });

                this._rgpd_enable_category("", service)
              }
            }
          }
        }

        this._rgpd_sync_category_checkboxes();
        this._rgpd_integrations_init();

        if (theme.Cookies.get("saved_categories") === "") {
          this._rgpd_track_status("do_not_track")
        }

        this._rgpd_set_category_as_body_class();
        this._rgpd_create_events();
        this._rgpd_enable_category("functional")
        this._show_cookie_banner()
      }

      _show_cookie_banner () {
        let disableCookiebanner = this._rgpd_is_speedbot();

        if (this.rgpd_banner && !disableCookiebanner) {
          this.rgpd_banner.querySelectorAll(".rgpd-links a:not(.rgpd-external), .rgpd-buttons a:not(.rgpd-external)").forEach(obj => {
            let docElement = obj;
            docElement.classList.add("rgpd-hidden");
          });

          this.rgpd_banner_container.style.display = '';

          if(this.rgpdData.test_mode == "true") {
            this.rgpd_banner_container.setAttribute('open', '');
            this.rgpd_banner.classList.add("rgpd-show");
          } else if(window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
            this._rgpd_set_banner_status();
          }
        }
      }

      _rgpd_set_banner_status (status) {
        let prevStatus = theme.Cookies.get("rgpd_cookie_status");
        status = typeof status !== "undefined" ? status : prevStatus;

        if (status !== prevStatus) {
          theme.Cookies.set("rgpd_cookie_status", status, this.rgpdData.cookie_expiry);
        }

        if (status.length === 0){
          status = "show"
        }

        if (status === "show") {
          this.rgpd_banner_container.setAttribute('open', '');
          prevStatus = "dismissed"
        } else {
          this.rgpd_banner_container.removeAttribute('open');
          prevStatus = "show"
        }

        if(this.rgpd_banner && status.length > 0) {
          this.rgpd_banner.classList.remove("rgpd-" + prevStatus);
          this.rgpd_banner.classList.add("rgpd-" + status);
        }
      }

      _rgpd_has_consent (category) {
        if (this._rgpd_is_bot()) {
          return !0
        }

        if (category === "functional") {
          return !0;
        }

        var has_consent, value;
        value = theme.Cookies.get(category);
        has_consent = value === "allow"

        return has_consent
      }

      _rgpd_is_service_denied (service) {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services

        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }

        if (!consented_services.hasOwnProperty(service))
          return !1
        else
          return !consented_services[service]
      }

      _rgpd_has_service_consent (service) {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services

        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }

        if (!consented_services.hasOwnProperty(service))
          return !1
        else
          return consented_services[service]
      }

      _rgpd_set_consent (category, value) {
        var previous_value = theme.Cookies.get(category);
        if (previous_value === value) return;

        var checked = value === "allow";
        document.querySelectorAll("input.rgpd-" + category).forEach(obj => { obj.checked = checked });

        theme.Cookies.set("rgpd_" + category, value, this.rgpdData.cookie_expiry);

        if (value === "allow") {
          this._rgpd_enable_category(category)
        }

        this._rgpd_wp_set_consent(category, value);

        if(value === "allow" && (category == "statistics" || category == "preferences" || category == "marketing")) {
          window.Shopify.customerPrivacy.setTrackingConsent(true, () => {})
        }

        if (category === "statistics") {
          this._rgpd_wp_set_consent("statistics-anonymous", "allow")
        }

        if (category === "marketing" && value === "deny") {
          this._rgpd_integrations_revoke();

          setTimeout(function () {
            location.reload()
          }, 500)
        }
      }

      _rgpd_deny_all () {
        for (var key in this.rgpd_categories) {
          if (this.rgpd_categories.hasOwnProperty(key)) this._rgpd_set_consent(this.rgpd_categories[key], "deny")
        }

        var consentLevel = rgpd_highest_accepted_category();
        var reload = !1;

        if (consentLevel !== "functional" || rgpd_exists_service_consent()) reload = !0
        if (rgpd_clear_all_rgpdData_cookies("rgpd_service")) reload = !0

        rgpd_clear_all_service_consents();
        rgpd_integrations_revoke();
        rgpd_fire_categories_event();
        rgpd_track_status();
      }

      _rgpd_create_events(){
        var self = this;

        document.addEventListener("rgpd_consent_action", function (e) {
          self._rgpd_set_consent(e.detail.category, "allow");
          self._rgpd_track_status()
        });

        this._rgpd_add_event("click", ".rgpd-accept", function (e) {
          e.preventDefault();
          self._rgpd_accept_all();
          self._rgpd_set_banner_status("dismissed");
          self._rgpd_track_status()
        });
        
        this._rgpd_add_event("click", ".rgpd-save-preferences", function (e) {
          let obj = e.target;
          self.rgpd_banner = obj.closest(".rgpd-cookiebanner");
          for (var key in self.rgpd_categories) {
            if (self.rgpd_categories.hasOwnProperty(key)) {
              var category = self.rgpd_categories[key];
              var categoryElement = self.rgpd_banner.querySelector("input.rgpd-" + category);
              if (categoryElement) {
                if (categoryElement.checked)
                  self._rgpd_set_consent(category, "allow")
                else
                  self._rgpd_set_consent(category, "deny")
              }
            }
          }
          self._rgpd_set_banner_status("dismissed");
          self._rgpd_track_status()
        });
        
        this._rgpd_add_event("click", ".rgpd-view-preferences", function (e) {
          let obj = e.target;
          self.rgpd_banner = obj.closest(".rgpd-cookiebanner");
          if (self.rgpd_banner.querySelector(".rgpd-categories").classList.contains("rgpd-fade-in")) {
            self.rgpd_banner.classList.remove("rgpd-categories-visible");
            self.rgpd_banner.querySelector(".rgpd-categories").classList.remove("rgpd-fade-in");
            self.rgpd_banner.querySelector(".rgpd-view-preferences").classList.remove('hide')
            self.rgpd_banner.querySelector(".rgpd-save-preferences").classList.add('hide')
          } else {
            self.rgpd_banner.classList.add("rgpd-categories-visible");
            self.rgpd_banner.querySelector(".rgpd-categories").classList.add("rgpd-fade-in");
            self.rgpd_banner.querySelector(".rgpd-view-preferences").classList.add('hide')
            self.rgpd_banner.querySelector(".rgpd-accept").classList.add('hide')
            self.rgpd_banner.querySelector(".rgpd-save-preferences").classList.remove('hide')
          }
        });
        
        this._rgpd_add_event("change", ".rgpd-manage-consent-container .rgpd-category", function (e) {
          for (var key in self.rgpd_categories) {
            if (self.rgpd_categories.hasOwnProperty(key)) {
              var category = self.rgpd_categories[key];
              var categoryElement = document.querySelector(".rgpd-manage-consent-container input.rgpd-" + category);
              if (categoryElement) {
                if (categoryElement.checked)
                  self._rgpd_set_consent(category, "allow")
                else
                  self._rgpd_set_consent(category, "deny")
                self._rgpd_set_banner_status("dismissed");
                self._rgpd_track_status()
              }
            }
          }
        });
        
        this._rgpd_add_event("click", ".rgpd-deny", function (e) {
          e.preventDefault();
          self._rgpd_set_banner_status("dismissed");
          self._rgpd_deny_all()
        });
        
        this._rgpd_add_event("click", "button.rgpd-manage-settings", function (e) {
          e.preventDefault();
          var catsContainer = document.querySelector(".rgpd-cookiebanner .rgpd-categories");
          var saveSettings = document.querySelector(".rgpd-save-settings");
          var manageSettings = document.querySelector("button.rgpd-manage-settings");
          if (!self._rgpd_is_hidden(catsContainer)) {
            saveSettings.style.display = "none";
            manageSettings.style.display = "block";
            catsContainer.style.display = "none"
          } else {
            saveSettings.style.display = "block";
            manageSettings.style.display = "none";
            catsContainer.style.display = "block"
          }
        });
        
        this._rgpd_add_event("click", "button.rgpd-manage-consent", function (e) {
          e.preventDefault();
          self._rgpd_set_banner_status("show")
        });

        document.addEventListener('shopify:section:load', function(e) {
          if("shopify-section-" + self.rgpd_banner_container.dataset.sectionId == e.target.id) {
            self.rgpdData.test_mode = e.target.querySelector('[data-test]').dataset.test;
            self.rgpd_banner_container = e.target.querySelector('[data-test]');
            self.rgpd_banner = self.rgpd_banner_container.querySelector('.rgpd-cookiebanner');
            self._show_cookie_banner();
          }
        });
      }
    }
    customElements.define('popup-rgpd', RGPD)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-spin"] && !Shopify.designMode) return;
  try {
    
  if(typeof PopupSpin !== 'function'){
    class PopupSpin extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        this.container = this.querySelector('modal-dialog')
        let date = new Date();
        date.setTime(date.getTime()+(parseInt(this.dataset.days)*24*60*60*1000));

        this.data = {
          test: this.dataset.test,
          end_test: this.dataset.endTest,
          desktop: this.dataset.desktop && document.documentElement.clientWidth > 779 ? true : false,
          mobile: this.dataset.mobile && document.documentElement.clientWidth <= 779 ? true : false,
          seconds: this.dataset.seconds,
          cookies_expiry: date.toGMTString(),
          timer: this.dataset.timer,
          customer: this.dataset.customer
        }

        this.Json = JSON.parse(document.querySelector('#PopupSpin-JSON').textContent);

        this.init();
      }

      init(){
        var self = this;

        if (this.data.test == "true"){
          if(this.data.end_test == "true"){
            self.showBar();
          } else {
            if (this.container.dataset.promoTest == "true")
              self.initWheel()
            else
              self.initWheel();

            setTimeout(function(){
              self.container.show();
            }, parseInt(this.data.seconds) * 1e3);
          }
        } else {
          if(this.data.desktop || this.data.mobile){
            if(this.data.customer == "false" && !theme.Cookies.get('popupSpinFilled')) {
              self.initWheel();
              if(!localStorage.getItem('popupSpinBarClosed')){
                setTimeout(function(){
                  self.container.show();
                }, parseInt(this.data.seconds) * 1e3);
              } else {
                document.querySelector('#popupSpinButton').classList.remove('hide');
              }
            } else if(theme.Cookies.get('popupSpinFilled')){
              this.container.classList.remove('fadeInRight', 'fadeInLeft');
              this.container.classList.add('fadeInUp');
              if(!localStorage.getItem('popupSpinBarClosed')){
                self.showBar();
              } else {
                document.querySelector('#popupSpinButton').classList.remove('hide');
              }
            }
          }
        }

        document.querySelector('#popupSpinButton').addEventListener('click', function(){
          if(!theme.Cookies.get('popupSpinFilled')) {
            self.container.show();
          } else {
            self.container.classList.remove('fadeInRight', 'fadeInLeft');
            self.container.classList.add('fadeInUp');
            self.showBar();
          }
        })

        this.container.addEventListener('modalClose', function(){
          document.querySelector('#popupSpinButton').classList.remove('hide');
          localStorage.setItem('popupSpinBarClosed', true);
        });

        this.container.addEventListener('modalOpen', function(){
          if(!document.querySelector('#popupSpinButton').classList.contains('hide'))
            document.querySelector('#popupSpinButton').classList.add('hide');
        });

        if(self.container.querySelector('.popup_spin_promo_copy_container button')){
          self.container.querySelector('.popup_spin_promo_copy_container button').addEventListener('click', function(){
            navigator.clipboard.writeText(this.dataset.code).then(() => {
              this.classList.add('copied');

              self.container.classList.remove('fadeInRight', 'fadeInLeft');
              self.container.classList.add('fadeInUp');
              setTimeout(() => {
                self.showBar();
              }, 3e3);
            });
          });
        }

        if(self.container.querySelector('form')){
          self.formSubmit();
        }
      }

      formSubmit(){
        var form = this.container.querySelector('form');
        var self = this;

        form.addEventListener('submit', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const body = new FormData(this)

          var email = this.querySelector('input[type="email"]').value;
          if (email != '') {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test(email)){
              fetch(form.getAttribute('action'), { method: "post", body: body })
              .then(() => {
                theme.Cookies.set('popupSpinFilled', true, self.data.cookies_expiry);
              }).catch((e) => {
                if(e.status == 429) {
                  // Allow for default redirect to challenge form, do not force
                  console.log('Allow default window redirection for challenge');
                }
              })
            }
          }
        });
      }

      initWheel(){
        var self = this;
        var wheelDataObject = {
          backgroundArray: [
          ],
          colorArray: [
          ],
          segmentValuesArray: [
          ],
          svgWidth: 1024,
          svgHeight: 768,
          wheelStrokeColor: self.Json.strokeColor,
          wheelStrokeWidth: self.Json.strokeWidth,
          wheelSize: 700,
          wheelTextOffsetY: 80,
          wheelTextSize: "1.6em",
          wheelImageOffsetY: 40,
          wheelImageSize: 50,
          centerCircleSize: 200,
          centerCircleStrokeColor: self.Json.strokeColor,
          centerCircleStrokeWidth: self.Json.strokeWidth,
          centerCircleFillColor: self.Json.centerFillColor,
          segmentStrokeColor: self.Json.strokeColor,
          segmentStrokeWidth: self.Json.strokeWidth,
          centerX: 512,
          centerY: 384,
          hasShadows: true,
          numSpins: 1,
          spinDestinationArray: [],
          minSpinDuration: 6,
          invalidSpinText:"INVALID SPIN. PLEASE SPIN AGAIN.",
          clickToSpin: true,
          spinDirection: "cw"
        }

        for(let i=0; i < this.Json.blocks.length; i++){
          this.Json.blocks[i].segmentValue.probability = (100 * this.Json.blocks[i].segmentValue.probability / this.Json.probaTotal).toFixed(1);
          wheelDataObject.backgroundArray.push(this.Json.blocks[i].background);
          wheelDataObject.colorArray.push(this.Json.blocks[i].color);
          wheelDataObject.segmentValuesArray.push(this.Json.blocks[i].segmentValue);
        }

        if(this.container.querySelector('.popup_spin__progress_bar')) this.initProgressBar();

        this.initSpin2WinWheel({ data: wheelDataObject, spinTrigger: this.container.querySelector('button[type="submit"]')});
      }

      initProgressBar(){
        var barFill = this.container.querySelector('.popup_spin__progress_bar_fill');
        barFill.style.width = parseFloat(barFill.dataset.width, 2) + '%';
      }

      initSpin2WinWheel(e){
        var self = this;
        theme.utils.getScript(Shopify.theme_settings.pluginSpin, "pluginSpin")
        .then(function(){
          self.initVariable();
          if(!e){ self.setInitPos(); self.showInitError('PLEASE INCLUDE THE INIT OBJECT'); return; }
          self.wheelSVG.setAttribute('viewBox', '0 0 ' + e.data.svgWidth + ' ' + e.data.svgHeight);
          self.dataObj = e.data;
          self.onGameEnd = (e.onGameEnd) ? e.onGameEnd : function(){};
          self.getGameProgress = function(){  return self.gameResultsArray; };
          self.onResult =  (e.onResult) ? e.onResult : function(){};
          self.onError = (e.onError) ? e.onError : function(){};
          self.spinButton = (e.spinTrigger) ? e.spinTrigger : null;
          self.setSpinTrigger();
          self.setInitData();
          self.setInitPos();
          self.drawSegments();
          self.wheelOutline.appendChild(self.getWheel())
          self.centerCircle.appendChild(self.getCenterCircle());
          self.setSpinDestinations();
          self.checkNumSegments();
        });
      }

      initVariable(){
        var self = this;
        this.select = function(s) {
          return self.container.querySelector(s);
        },
        this.selectAll = function(s) {
          return self.container.querySelectorAll(s);
        },
        this.FF = !(window.mozInnerScreenX == null),
        this.xmlns = "http://www.w3.org/2000/svg",
        this.xlinkns = "http://www.w3.org/1999/xlink",
        this.wheelSVG = this.select('.popup_spin__svg'),
        this.wheel = this.select('.wheel'),
        this.peg = this.select('.pegContainer'),
        this.wheelOutline = this.select('.wheelOutline'),
        this.mainContainer = this.select('.mainContainer'),
        this.valueContainer = this.select('.valueContainer'),
        this.centerCircle = this.select('.centerCircle'),
        this.reward = this.select('.popup_spin__promo_code p'),
        this.rewardText = this.select('.popup_spin__promo_text'),
        this.mailEmpty = this.select('.newsletter_empty'),
        this.mailInvalid = this.select('.newsletter_invalid'),
        this.dataObj,
        this.svgWidth,
        this.svgHeight,
        this.wheelStrokeColor,
        this.wheelStrokeWidth,
        this.wheelFillColor = 'transparent',
        this.wheelSize,
        this.wheelRadius,
        this.colorArray,
        this.wheelTextOffsetY,
        this.wheelImageOffsetY,
        this.wheelTextSize = '1.2rem',
        this.wheelImageSize,
        this.wheelDragger,
        this.currentWheelRoation,
        this.centerCircleStrokeColor,
        this.centerCircleStrokeWidth,
        this.centerCircleFillColor,
        this.centerCircleSize,
        this.centerCircleRadius,
        this.segmentStrokeColor,
        this.segmentStrokeWidth,
        this.segmentValuesArray,
        this.numSegments,
        this.numSpins,
        this.rotationStep,
        this.segmentStep,
        this.oldWheelPos,
        this.currentWheelPos = 0,
        this.centerX,
        this.centerY,
        this.backgroundArray,
        this.spinCount = 0,
        this.spinMultiplier = 2,
        this.colorCount = 0,
        this.startAngle = 0,
        this.endAngle = this.startAngle,
        this.segmentArray = [],
        this.strokeArray = [],
        this.minSpinDuration,
        this.invalidSpinText,
        this.hasShadows,
        this.clickToSpin,
        this.spinButton = null,
        this.onResult,
        this.onGameEnd,
        this.onError,
        this.spinVelocityTracker,
        this.gameResultsArray = [],
        this.spinDestinationArray,
        this.randomSpins = true,
        this.spinDirection,
        this.numRevsPerDestination,
        this.invalidSpinThreshold,
        this.probabilityArray = null,
        this.hasProbability = true,
        this.requiredProb,
        this.initError1 = "Invalid destination set - please ensure the destination in spin Destination Array is greater than 0 and less than or equal to the number of segments",
        this.initError2 = "Not enough options. Please add more options to show the wheel / Pas assez d'options . Ajoutez des options pour afficher la roue",
        this.probabilityErrorStr = "If you have set JSON probability values they must add up to 100"
      }

      setInitData() {
        this.wheelStrokeColor = this.dataObj.wheelStrokeColor;
        this.wheelSize = this.dataObj.wheelSize;
        this.wheelRadius = this.wheelSize / 2;
        this.colorArray = this.dataObj.colorArray;
        this.wheelStrokeColor = this.dataObj.wheelStrokeColor;
        this.wheelStrokeWidth = this.dataObj.wheelStrokeWidth;
        this.wheelTextOffsetY = this.dataObj.wheelTextOffsetY;
        this.wheelImageOffsetY = this.dataObj.wheelImageOffsetY;
        this.wheelImageSize = this.dataObj.wheelImageSize;
        this.wheelTextSize = this.dataObj.wheelTextSize;
        this.centerCircleStrokeColor = this.dataObj.centerCircleStrokeColor;
        this.centerCircleStrokeWidth = this.dataObj.centerCircleStrokeWidth;
        this.centerCircleFillColor = this.dataObj.centerCircleFillColor;
        this.centerCircleSize = this.dataObj.centerCircleSize;
        this.centerCircleRadius = this.centerCircleSize / 2;
        this.segmentStrokeColor = this.dataObj.segmentStrokeColor;
        this.segmentStrokeWidth = this.dataObj.segmentStrokeWidth;
        this.segmentValuesArray = this.dataObj.segmentValuesArray;
        this.numSegments = this.segmentValuesArray.length;
        this.numSpins = (this.dataObj.numSpins == -1) ? 9999999999999999 : parseInt(this.dataObj.numSpins);
        this.minSpinDuration = this.dataObj.minSpinDuration;
        this.invalidSpinText = this.dataObj.invalidSpinText;
        this.clickToSpin = this.dataObj.clickToSpin;
        this.rotationStep = 360 / this.numSegments;
        this.segmentStep = this.rotationStep / 2;
        this.R = 640;
        this.centerX = this.dataObj.centerX;
        this.centerY = this.dataObj.centerY;
        this.backgroundArray = this.dataObj.backgroundArray;
        this.hasShadows = this.dataObj.hasShadows;
        this.spinDestinationArray = this.dataObj.spinDestinationArray;
        this.spinDirection = (this.dataObj.spinDirection == "cw") ? -1 : 1;
        this.numRevsPerDestination = this.spinDirection * (3 * 360);
        this.invalidSpinThreshold = 0.5;
        if (this.hasShadows) {
          this.wheelOutline.setAttributeNS(null, 'filter', 'url(#extshadow)');
          this.centerCircle.setAttributeNS(null, 'filter', 'url(#centershadow)');
        }
      }

      showInitError(str) {
        TweenMax.set([this.wheelSVG, this.peg], { visibility: 'hidden' }) 
      }

      onResult(e){
        thisWheel.onResult(e)
      }

      onError(e){
        thisWheel.onError(e)
      }

      onGameEnd(e){
        thisWheel.onGameEnd(e)
      }

      setInitPos(){
        var self = this;
        var PegHeight = this.peg.getBoundingClientRect().height;
        var PegWidth = this.peg.getBoundingClientRect().width;
        this.wheelSVG.style.visibility = "visible";

        TweenMax.set(self.wheel, {
          svgOrigin: self.centerX + ' ' + self.centerY,
          x: 0,
          y: 0
        })

        TweenMax.set(self.peg, {
          x: self.centerX - (PegWidth / 2) - 6,
          y: self.wheelRadius - (PegHeight / 2) - 365,
          transformOrigin: '100% 100%',
          visibility: 'visible'
        })

        TweenMax.set(self.mainContainer, {
          svgOrigin: self.centerX + ' ' + self.centerY,
          rotation: -90
        })
      }

      randomBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
      }

      setSpinDestinations() {
        if(this.numSpins == 0){
          this.showInitError('numSpins MUST BE GREATER THAN 0')
          return;
        }
        this.createClickToSpin();

        if (this.spinDestinationArray.length > 0) {
          this.randomSpins = false;
          this.numSpins = this.spinDestinationArray.length;
          for (var i = 0; i < this.spinDestinationArray.length; i++) {
            if (this.spinDestinationArray[i] > this.numSegments || this.spinDestinationArray[i] === 0) {
              this.showInitError(initError1);
              this.reward.style.backgroundColor = 'red';
              return;
            }
            this.spinDestinationArray[i] = this.spinDestinationArray[i] - 1;
            this.spinDestinationArray[i] = ((this.spinDestinationArray[i] * -1) * this.rotationStep) - (this.numRevsPerDestination * this.spinMultiplier);
            this.spinMultiplier += 2;
          }
        }
      }

      drawSegments() {
        var x1, x2, y1, y2, m2, n2, d, p, g, destFill;
        for (var i = 0; i < this.numSegments; i++) {
          this.startAngle = -this.segmentStep;
          this.endAngle = this.startAngle + this.rotationStep;

          x1 = (this.centerX + this.wheelRadius * Math.cos(Math.PI * this.startAngle / 180));
          y1 = (this.centerY + this.wheelRadius * Math.sin(Math.PI * this.startAngle / 180));
          x2 = (this.centerX + this.wheelRadius * Math.cos(Math.PI * this.endAngle / 180));
          y2 = (this.centerY + this.wheelRadius * Math.sin(Math.PI * this.endAngle / 180));
          m2 = (this.centerX + 1.03 * this.wheelRadius * Math.cos(Math.PI * this.endAngle / 180));
          n2 = (this.centerY - 1.03 * this.wheelRadius * Math.sin(Math.PI * this.endAngle / 180));

          d = "M" + this.centerX + "," + this.centerY + "  L" + x1 + "," + y1 + "  A" + this.wheelRadius + "," + this.wheelRadius + " 0 0,1 " + x2 + "," + y2 + "z";

          g = document.createElementNS(this.xmlns, 'g');
          p = document.createElementNS(this.xmlns, 'path');

          g.appendChild(p);
          this.wheel.appendChild(g);

          TweenMax.set(p, {
            rotation: (i * this.rotationStep),
            svgOrigin: this.centerX + ' ' + this.centerY,
            x: 0,
            y: 0
          })
          
          p.setAttributeNS(null, 'd', d);

          if (this.backgroundArray[i]) {
            destFill = this.backgroundArray[i];
          } else {
            destFill = this.backgroundArray[this.colorCount];
            this.colorCount++;

            if (this.colorCount == this.backgroundArray.length) {
              this.colorCount = 0;
            }
          }

          p.setAttributeNS(null, "fill", destFill);
          p.setAttributeNS(null, "stroke", 0);
          this.strokeArray.push({ m2: m2, n2: n2 });
          this.segmentArray.push({ path: p, x1: x1, x2: x2, y1: y1, y2: y2 });
        }

        if (this.segmentStrokeWidth > 0) {
          this.drawSegmentStrokes()
        }

        this.addValues()
      }

      drawSegmentStrokes() {
        for (var i = 0; i < this.numSegments; i++) {
          var l = document.createElementNS(this.xmlns, 'line');
          l.setAttributeNS(null, 'x1', this.centerX);
          l.setAttributeNS(null, 'x2', this.strokeArray[i].m2);
          l.setAttributeNS(null, 'y1', this.centerY);
          l.setAttributeNS(null, 'y2', this.strokeArray[i].n2);
          l.setAttributeNS(null, 'stroke', this.segmentStrokeColor);
          l.setAttributeNS(null, 'stroke-width', this.segmentStrokeWidth);
          l.setAttributeNS(null, 'stroke-linecap', "round");
          this.wheel.appendChild(l);

          TweenMax.set(l, {
            rotation: (i * this.rotationStep),
            svgOrigin: this.centerX + ' ' + this.centerY
          })
        }
      }

      addValues() {
        var self = this;
        for (var i = 0; i < this.numSegments; i++) {
          var g = document.createElementNS(this.xmlns, 'g'), destFill;
          var t = document.createElementNS(this.xmlns, 'text');
          var lines = this.segmentValuesArray[i].value.split('^'), tn, ts;

          lines.forEach(function (value,index) {
            tn = document.createTextNode(value);
            ts = document.createElementNS(self.xmlns, "tspan");
            ts.setAttributeNS(null,'dy',  (index) ? "1.2em" : 0);
            ts.setAttributeNS(null,'x', self.centerX);
            ts.setAttributeNS(null,'text-anchor','middle');
            ts.appendChild(tn);
            t.appendChild(ts);
          });

          g.appendChild(t);
          t.setAttribute('class', 'wheelText');

          if (this.colorArray[i]) {
            destFill = this.colorArray[i];
          } else {
            destFill = this.colorArray[this.colorCount];
            this.colorCount++;
            if (this.colorCount == this.colorArray.length) {
              this.colorCount = 0;
            }
          }

          t.setAttributeNS(null, 'fill', destFill);
          t.setAttributeNS(null, 'x', this.centerX);
          t.setAttributeNS(null, 'y', this.centerY - this.wheelRadius + this.wheelTextOffsetY);
          t.style.fontSize = this.wheelTextSize;

          this.valueContainer.appendChild(g);

          TweenMax.set(g, {
            svgOrigin: this.centerX + ' ' + this.centerY,
            rotation: i * this.rotationStep
          })
        }

        TweenMax.set(this.valueContainer, {
          svgOrigin: this.centerX + ' ' + this.centerY
        })
      }

      getWheel() {
        var g = document.createElementNS(this.xmlns, 'g');
        var c = document.createElementNS(this.xmlns, 'circle');
        this.wheelOutline.appendChild(g);

        c.setAttributeNS(null, 'fill', this.wheelFillColor);
        c.setAttributeNS(null, 'stroke', this.wheelStrokeColor);
        c.setAttributeNS(null, 'stroke-width', this.wheelStrokeWidth);
        c.setAttributeNS(null, 'cx', this.centerX);
        c.setAttributeNS(null, 'cy', this.centerY);
        c.setAttributeNS(null, 'r', this.wheelRadius);
        g.appendChild(c);

        return g;
      }

      getCenterCircle() {
        var c = document.createElementNS(this.xmlns, 'circle');

        c.setAttributeNS(null, 'fill', this.centerCircleFillColor);
        c.setAttributeNS(null, 'stroke', this.centerCircleStrokeColor);
        c.setAttributeNS(null, 'stroke-width', this.centerCircleStrokeWidth);
        c.setAttributeNS(null, 'cx', this.centerX);
        c.setAttributeNS(null, 'cy', this.centerY);
        c.setAttributeNS(null, 'r', this.centerCircleRadius);

        return c;
      }

      onWheelPress() {
        this.reward.style.visibility = 'hidden';
      }

      onWheelDragEnd() {
        this.disableWheel();
        if (this.randomSpins) { this.spinVelocityTracker = VelocityTracker.track(this.wheel, "rotation"); }
      }

      updateWheelBounds(){
        if(this.clickToSpin)return;
        this.wheelDragger[0].applyBounds({ minRotation: this.spinDirection * -9999999999999999, maxRotation: this.currentWheelRoation });
      }

      getRandomSpinFunction(multiplier) {
        var f = function(endValue) { return (Math.round((endValue / this.rotationStep)) * this.rotationStep) - multiplier }
        return f;
      }

      getRandomClickSpin() {
        var val = - (this.rotationStep * this.randomBetween(0, this.numSegments)) - this.numRevsPerDestination * this.spinMultiplier;
        return val
      }

      getProbabilityClickSpin(){
        var probId = Math.floor(Math.random() * this.probabilityArray.length);
        var probSeg = this.probabilityArray[probId];
        var val = - (this.rotationStep * probSeg) - this.numRevsPerDestination * this.spinMultiplier
        return val
      }

      checkHasProbability(){
        this.hasProbability = true;
        this.segmentValuesArray.forEach( function(el, val){
          if(isNaN(el.probability)){ hasProbability = false; } 
        })

        if(this.hasProbability){
          this.spinDestinationArray = [];
          this.numSpins = (this.dataObj.numSpins == -1) ? 9999999999999999 : parseInt(this.dataObj.numSpins);
          this.checkProbabilityValues();
        }
      }

      createProbabilityArray(){
        this.probabilityArray = [];
        var self = this;
        this.segmentValuesArray.forEach( function(el, val){ for(var i = 0; i < el.probability; i++){ self.probabilityArray.push(val);} })
      }

      checkProbabilityValues(){
        var totalProb = 0;
        this.segmentValuesArray.forEach( function(el, val){ totalProb += parseFloat(el.probability,2); })
        this.requiredProb = Math.round(totalProb);
        if(Math.ceil(totalProb) == this.requiredProb || Math.floor(totalProb) == this.requiredProb){
          this.createProbabilityArray();
        } else {
          var r = confirm("Total probability: " + totalProb + ' - ' + this.probabilityErrorStr);
          if (r == true) {
            TweenMax.set(this.wheelContainer, { autoAlpha:0 })
          }
        }
      }

      createClickToSpin(){
        if(this.checkHasProbability()){
          this.createProbabilityArray();
        }

        if(this.spinButton){
          this.spinButton.onclick = this.getTrigger();
        }  else {
          this.spinButton = this.wheel;
          this.wheel.onclick = this.getTrigger();
        }
      }

      onButtonPress() {
        this.container.classList.add('popup_spin--game');

        this.spinButton.onclick = null;
        this.spinMultiplier += 2;
      }

      spinComplete() {
        this.currentWheelRoation = this.wheel._gsTransform.rotation;
        var normalizedRotation = Math.round(this.currentWheelRoation % 360);
        normalizedRotation = (normalizedRotation > 0) ? 360 - normalizedRotation : normalizedRotation;
        normalizedRotation = (normalizedRotation < 0) ? normalizedRotation *= -1 : normalizedRotation;

        var segId = Math.abs(Math.round(normalizedRotation / this.rotationStep));
        this.showResult(segId);

        if (this.randomSpins) {
          if (this.numSpins > -1) {
            this.spinCount++;
          }
          else {
            return;
          }
        } else {
          this.spinCount++;
        }

        if (this.spinCount >= this.numSpins) {
          this.endGame();
          return;
        }
      }

      showResult(e) {
        this.updateWheelBounds();
        this.container.querySelector('.popup_spin__text_column').classList.add('hide');
        this.container.classList.remove('popup_spin--game');
        this.container.classList.add('popup_spin--promo');
        var resultObj;

        if (e == "invalidSpin") {
          this.showReward(this.invalidSpinText);
          resultObj = {
            target: this.thisWheel,
            type:'error',
            spinCount: this.spinCount,
            win: null,
            msg: this.invalidSpinText
          };
          this.onError(resultObj);
          this.gameResultsArray.push(resultObj);
          return;
        }
        if (!isNaN(e)) {
          this.showReward(this.segmentValuesArray[e]);

          if(this.segmentValuesArray[e].reward){
            localStorage.setItem('popupSpinCode', this.segmentValuesArray[e].reward);
            localStorage.setItem('storedDiscount', this.segmentValuesArray[e].reward);
            localStorage.setItem("discount_code", this.segmentValuesArray[e].reward);

            window.ajaxURL('/discount/' + this.segmentValuesArray[e].reward, 'POST')
            .then(() => {})
            .catch((e) => {
              console.log(e);
            })

            window.ajaxURL('checkout?discount=' + this.segmentValuesArray[e].reward, 'POST')
            .then(() => {})
            .catch((e) => {
              console.log(e);
            })

            var btnCopy = this.select(".popup_spin_promo_copy_container button");
            btnCopy.dataset.code = this.segmentValuesArray[e].reward;

            resultObj = {
              target: this.thisWheel,
              type: 'result',
              spinCount: this.spinCount,
              win: this.segmentValuesArray[e].reward,
              msg: this.segmentValuesArray[e].result
            };
            this.onResult(resultObj);
            this.gameResultsArray.push(resultObj);
          } else if (this.segmentValuesArray[e].product){
            const body = {
              id: this.segmentValuesArray[e].product,
              quantity: 1
            }

            resultObj = {
              target: this.thisWheel,
              type: 'result',
              spinCount: this.spinCount,
              win: this.segmentValuesArray[e].reward,
              msg: this.segmentValuesArray[e].result
            };

            this.onResult(resultObj);
            this.gameResultsArray.push(resultObj);

            this.select(".popup_spin_promo_copy_container").classList.add('hide');

            fetch(`${theme.routes.cart_add_url}?id=${this.segmentValuesArray[e].product}&quantity=1`, { ...theme.utils.fetchConfig('javascript') })
            .then(function(){
              if (Shopify.theme_settings.atc_action == "cart" && window.location.href.indexOf("cart") == -1 ){
                window.location.href = theme.routes.cart_url;
                return;
              } else if (Shopify.theme_settings.atc_action == "checkout"){
                window.location.href = '/checkout';
                return;
              }

              document.dispatchEvent(new CustomEvent('updateCart'));

              if(document.querySelectorAll('.cart-bubble')) {
                fetch('/cart.js', { ...theme.utils.fetchConfig('javascript')})
                .then((cart) => cart.json())
                .then(function(cart){
                  document.querySelectorAll('.cart-bubble').forEach((bubble) => {
                    bubble.classList.remove('hide');
                    bubble.innerHTML = cart.item_count
                  });
                });
              }
            }).catch((e) => {
              console.error(e);
            })
          }
        }
        this.endGame();
      }

      showBar() {
        var self = this;

        document.querySelector('body').classList.remove('overflow-hidden', 'overflow-hidden-fixed');
        this.container.querySelector('.popup_spin_bar').classList.remove('hide');
        this.container.querySelector('.popup_spin__content').classList.add('hide');
        this.container.classList.add('popup_spin--end');
        
        document.querySelector('footer').style.marginBottom = this.container.getBoundingClientRect().height + 'px';

        this.container.querySelector('.popup_spin_bar__promo_code').innerHTML = localStorage.getItem('popupSpinCode');

        var timerContainer = this.container.querySelector('.popup_spin_bar__timer');

        let time = parseInt(this.container.dataset.timer);

        let now, finalDate, timerIntervalStarted = false;

        if(theme.Cookies.get('popupSpinTimerEnd')) {
          now = theme.Cookies.get('popupSpinTimerActual');
          finalDate = theme.Cookies.get('popupSpinTimerEnd');
          if(finalDate - now > -36e5) self.container.show(); 
        } else {
          sessionStorage.setItem('popupSpinCode', localStorage.getItem('popupSpinCode'), self.data.cookies_expiry);
          now = new Date().getTime();
          finalDate = new Date(now + time * 6e4).getTime();
          theme.Cookies.set('popupSpinTimerActual', now, self.data.cookies_expiry);
          theme.Cookies.set('popupSpinTimerEnd', finalDate, self.data.cookies_expiry);
          self.container.show(); 
        }

        this.timer = () => {
          now = new Date().getTime();
          theme.Cookies.set('popupSpinTimerActual', now, self.data.cookies_expiry);
          let diff = finalDate - now;

          if(diff < 0) {
            this.container.querySelector('.popup_spin_bar__text').innerHTML = '<span>'+ Shopify.translation.popupSpin_timer_ended +'</span>';
            if(diff <=-36e5)  clearInterval(self.timerInterval);
          } else {
            let minutes = Math.floor(diff % (1e3*60*60)/ (1e3*60));
            let seconds = Math.floor(diff % (1e3*60) / 1e3);

            minutes <= 9 ? minutes = `0${minutes}` : minutes;
            seconds <= 9 ? seconds = `0${seconds}` : seconds;

            if(minutes > 0) var text = Shopify.translation.date.m
            else var text = Shopify.translation.date.minute

            timerContainer.querySelector('span').textContent = minutes + ':' + seconds + ' ' + text;
          }
        };

        this.timer();
        timerIntervalStarted = true;
        this.timerInterval = setInterval(self.timer, 1e3);
      }

      getTrigger(){
        var self = this;
        return function(){
          var email = self.container.querySelector('form input[type="email"]').value;
          if (email != '') {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test(email)){
              if(self.hasProbability){
                ThrowPropsPlugin.to(self.wheel, {
                  throwProps:{
                    rotation:{
                      velocity: (self.spinDirection == 1) ? self.randomBetween(-700, -500) : self.randomBetween(500, 700),
                      end: self.getProbabilityClickSpin()
                    },
                  },
                  onStart: self.onButtonPress.bind(self),
                  onUpdate: self.throwUpdate.bind(self),
                  onComplete: self.spinComplete.bind(self),
                  overshootTolerance: 0,
                  ease: Back.easeOut.config(0.2)
                });
              } else {
                ThrowPropsPlugin.to(self.wheel, {
                  throwProps: {
                    rotation: {
                      velocity: self.randomBetween(-700, -500), 
                      end: (self.randomSpins) ? self.getRandomClickSpin() : [self.spinDestinationArray[self.spinCount]]
                    }
                  },
                  onStart: self.onButtonPress.bind(self),
                  onUpdate: self.throwUpdate.bind(self),
                  onComplete: self.spinComplete.bind(self),
                  overshootTolerance: 0,
                  ease: Back.easeOut.config(0.2)
                });
              }
            } else {
              self.showMailError();
            }
          } else {
            self.showMailEmpty();
          }
        }
      }

      throwUpdate() {
        var self = this;
        self.oldWheelPos = self.currentWheelPos;

        this.currentWheelPos = Math.round(self.wheel._gsTransform.rotation / this.rotationStep);
        TweenMax.set(self.valueContainer, { rotation: self.wheel._gsTransform.rotation })

        if (this.currentWheelPos != this.oldWheelPos) {
          var PegHeight = this.peg.getBoundingClientRect().height;
          var PegWidth = this.peg.getBoundingClientRect().width;
          var rotation = (this.currentWheelPos > this.oldWheelPos) ? -35 : 35;

          TweenMax.fromTo(self.peg, 0.2, { 
            rotation: rotation, 
            x: self.centerX - (PegWidth / 2) - 6,
            y: self.wheelRadius - (PegHeight / 2) - 365,
            transformOrigin: "22.139px 22.139px"
          },
          {
            onStart: null,
            rotation: 0,
            x: self.centerX - (PegWidth / 2) - 6,
            y: self.wheelRadius - (PegHeight / 2) - 365,
            transformOrigin: "22.139px 22.139px",
            ease: Back.easeOut
          })
        }
      }

      showMailEmpty(){
        this.mailEmpty.classList.add('show');
        setTimeout (function () {
          this.mailEmpty.classList.remove('show');
        }, 5000);
      }

      showMailError(){
        this.mailInvalid.classList.add('show');
        setTimeout (function () {
          this.mailInvalid.classList.remove('show');
        }, 5000);
      }

      endGame() {
        this.disableWheel();
        TweenMax.set(this.wheelSVG, { alpha: 0.3 })
        this.onGameEnd({target: this, results: this.gameResultsArray});
      }

      disableWheel() {
        if(this.clickToSpin) return; this.wheelDragger[0].disable();
      }

      enableWheel() {
        if(this.clickToSpin) return; this.wheelDragger[0].enable();
      }

      checkNumSegments() {
        if (this.numSegments <= 1) {
          this.showInitError(this.initError2)
          TweenMax.set(this.wheelSVG, { visibility: 'hidden' })
          this.reward.style.backgroundColor = 'red';
        }
      }

      setSpinTrigger(){
        if(this.spinButton){
          this.clickToSpin = true;
        }

        if(this.clickToSpin){
          if(this.spinButton){
            this.spinButton.onclick = this.getTrigger();
          } else {
            this.wheel.onclick = this.getTrigger();
          }
        }
      }

      showReward(str) {
        if(str.reward){
          this.reward.innerHTML = str.reward;
        } else {
          this.reward.innerHTML = str.value;
        }
        this.rewardText.innerHTML = str.result;
      }

      onBlockDeselect(){
        this.container.hide();
        if(this.timerInterval) {
          clearInterval(this.timerInterval);
        }
      }
    }
    customElements.define('popup-spin', PopupSpin)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopping-feed-insta"] && !Shopify.designMode) return;
  try {
    
  if (typeof ShoppingFeedInsta !== 'function'){
    class ShoppingFeedInsta extends HTMLElement {
      constructor(){
        super();
      }
      
      connectedCallback(){
        var self = this;
        this.sectionId = 'shopify-section-' + this.dataset.sectionId;
        this.swiper = null;
        this.modalSwiper = null;
        this.modal = this.querySelector('modal-dialog');
        this.init();

        document.addEventListener('shopify:block:select', function(e) {
          if(document.querySelector('#' + e.target.id)) {
            document.querySelector('#' + e.target.id).click();
          }
        })
      }

      init(){
        var self = this;

        this.querySelectorAll('modal-opener').forEach( (modal) => {
          modal.addEventListener('modalOpen', function(e){
            self.renderPopup(this);
          });
        });

        this.modal.addEventListener('modalClose', function(e){
          self.destroyPopup(this);
        });
          
        this.querySelectorAll('modal-opener').forEach( (modal) => {
          modal.addEventListener('modalOpen', function(e){
            self.renderPopup(this);
          });
        });
      }
      
      renderPopup(modalContent){
        const self = this;
        const slides = modalContent.querySelector('.content--products-container');
        const image = modalContent.querySelector('.content--wrapper > .image-container');
        const postLink = modalContent.querySelector('article').getAttribute('data-post-link');
        const username = modalContent.querySelector('.content--text span').innerHTML;
        const pins = modalContent.querySelector('.shopping__pins');
        
        if(self.modal.querySelector('.modal-products-caption__content .shopping__pins')) {
          self.modal.querySelector('.modal-products-caption__content .shopping__pins').remove()
        }

        self.modal.querySelector('.image-container').innerHTML = image.innerHTML;
        self.modal.querySelector('.modal-products-caption__info-name').href = postLink;
        self.modal.querySelector('.modal-products-caption__info-name span').innerHTML = username;
        self.modal.querySelector('.swiper-wrapper').innerHTML = slides.innerHTML;
    
        self.modal.querySelectorAll('img', 'svg').forEach((lazyBackground) => {
          theme.utils.lazyBackgroundObserver.observe(lazyBackground);
        });

        self.modal.querySelector('.modal-loading').style.display = "none";

        if(!pins){
          return 
        }

        self.modal.querySelector('.modal-products-caption__content').appendChild(pins.cloneNode(true));
        const modal_pins = self.modal.querySelectorAll('.modal-products-caption__content .product-pin');

        modal_pins.forEach((pin) => {
          pin.addEventListener('click', function(){
            self.modalSwiper = self.modal.querySelector('.swiper')
            self.modalSwiper.swiper.slideTo(this.getAttribute('data-product') - 1);
          });
        });
      }

      destroyPopup() {
        var self = this;
        if(self.modalSwiper != null){
          self.modalSwiper.swiper.destroy();
          self.modal.querySelector('.swiper-wrapper').innerHTML = '';
          self.modal.querySelector('.image-container > *').remove();
        }
        self.modalSwiper = null;
        self.modal.querySelector('.modal-loading').style.display = "";
      }
    }
    customElements.define('shopping-insta', ShoppingFeedInsta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-feed"] && !Shopify.designMode) return;
  try {
    
  // --- Section : social-feed
  if (typeof Feed !== 'function'){
    class Feed extends HTMLElement {
      constructor(){
        super();
      }

      connectedCallback(){
        if(this.querySelector('[data-twitter]')){
          this.twitter();
        }

        if(this.querySelector('[data-pinterest]')){
          this.pinterest();
        }

        if(this.querySelector('[data-instagram]')){
          this.instagram_init();
        }
      }

      twitter(){
        var twitterContainer = this.querySelector('[data-twitter]');
        var options = {
          container: twitterContainer,
          sourceType: twitterContainer.getAttribute('data-source-type'),
          name: twitterContainer.getAttribute('data-screen-name'),
          last: twitterContainer.getAttribute('data-last'),
          theme: twitterContainer.getAttribute('data-theme'),
          tweetLimit: parseInt(twitterContainer.getAttribute('data-tweet-limit'))
        };

        var parameters = {
          theme: options.theme,
          tweetLimit: options.tweetLimit,
          chrome: "noheader nofooter"
        };

        if(options.sourceType == 'profile') {
          var source = {
            sourceType: options.sourceType,
            screenName: options.name
          };
        } else if (options.sourceType == 'tweet') {
          var source = options.last;
        } else {
          var source = {
            sourceType: options.sourceType,
            ownerScreenName: options.name,
            slug: options.last
          };
        }

        if (typeof window.twttr === 'undefined') {
          window.twttr = window.twttr || {};
          window.twttr._e = [];
          window.twttr.ready = function(f) {
            window.twttr._e.push(f);
          };
          theme.utils.getScript('https://platform.twitter.com/widgets.js', "twitter-wjs")
          .then(function(){
            if (options.sourceType != 'tweet') {
              window.twttr.widgets.createTimeline(
                source,
                twitterContainer,
                parameters
              );
            } else {
              window.twttr.widgets.createTweet(
                source,
                twitterContainer,
                parameters
              );
            }
          });
        } else {
          if (options.sourceType != 'tweet') {
            window.twttr.widgets.createTimeline(
              source,
              twitterContainer,
              parameters
            );
          } else {
            window.twttr.widgets.createTweet(
              source,
              twitterContainer,
              parameters
            );
          }
        }
      }

      pinterest(){
        if(typeof window.PinUtils === 'undefined') {
          !function (a, b, c) {
            var d, e, f;
            d = "PIN_" + ~~((new Date).getTime() / 864e5),
            a['PinId'] = d,
            a[d] = 1,
            a.setTimeout(function () {
              e = b.getElementsByTagName("SCRIPT")[0],
              f = b.createElement("SCRIPT"),
              f.type = "text/javascript",
              f.id = "pinterest-wjs",
              f.async = !0, f.src = c.mainUrl + "?" + Math.random(),
              e.parentNode.insertBefore(f, e)
            }, 10)
          }(window, document, { mainUrl: "https://assets.pinterest.com/js/pinit_main.js" });
        } else {
          document.querySelector('script[src*="assets.pinterest.com/js/pinit_main.js"]').remove();
          if(document.querySelector("pinterest-wjs")) document.querySelector("pinterest-wjs").remove();
          !function (a, b, c) {
            var e, f;
            a['PinId'] = 1,
            a.setTimeout(function () {
              e = b.getElementsByTagName("SCRIPT")[0],
              f = b.createElement("SCRIPT"),
              f.type = "text/javascript",
              f.async = !0, f.src = c.mainUrl + "?" + Math.random(),
              e.parentNode.insertBefore(f, e)
          }, 10)
          }(window, document, { mainUrl: "https://assets.pinterest.com/js/pinit_main.js" });
        }
      }

      instagram_init(){
        var self = this;
        const instagramContainer = this.querySelector('[data-instagram]');
        this.loadMore = '<div class="instafeed-loadmore"><div class="btn--small btn">' + Shopify.translation.instafeed_show_more + '</div></div>';
        this.loader = '<div class="instafeed-loader"></div>';
        this.options = {
          container: instagramContainer,
          swiperContainer: instagramContainer.querySelector('.swiper'),
          accountType: 'graph.instagram.com/me/',
          src: instagramContainer.dataset.src,
          token_api: instagramContainer.dataset.tokenApi,
          fields: instagramContainer.dataset.fields,
          limit: parseInt(instagramContainer.dataset.limit),
          limitMob: parseInt(instagramContainer.dataset.limitMob),
          style: instagramContainer.dataset.style,
          template: instagramContainer.dataset.template,
          layout: instagramContainer.dataset.layout
        };

        this.loadMoreContainer = this.options.container.querySelector('.instafeed-loadmore')
        this.swiperWrapper = this.options.container.querySelector('.swiper-wrapper')

        if (typeof window.insta === 'undefined') {
          window.instaToken = this.options.token_api || {};
          
          theme.utils.getScript(self.options.src, "instagram-wjs")
          .then(function(){
            self.instagram_request();
          })
        } else {
          this.instagram_request();
        }
      }

      async refreshAccessToken(token_api) {
        await fetch(`https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=${token_api}`);
      }

      formatDate(timestamp) {
        var date = new Date(timestamp);
        var month = Shopify.translation.date[date.getMonth()];
        var year = date.getFullYear();
        var day = date.getDate();
        return day + ' ' + month + ' ' + year;
      }

      replaceTemplateVariables(template, item) {
        let ItemTemplate = template
          .replace(/--([\s\\id.]+)--/g, item.id)
          .replace(/--([\s\\permalink.]+)--/g, item.permalink)
          .replace(/--([\s\\username.]+)--/g, item.username);
          
        ItemTemplate = ItemTemplate.replace(/--([\s\\date.]+)--/g, this.formatDate(item.timestamp));

        if (item.caption) {
          const caption = item.caption;
          const captionTruncate = caption.length > 30 ? caption.substring(0, 30) + "..." : caption;
          ItemTemplate = ItemTemplate.replace(/--([\s\\caption.]+)--/g, caption).replace(/--([\s\\alt.]+)--/g, captionTruncate);
        }

        if(item.media_type == "VIDEO" && this.options.style == 'classic') {
          ItemTemplate = ItemTemplate.replace("img", "img style='display: none'")
          .replace("insta-icon-carousel", "insta-icon-carousel hide")
          .replace(/--([\s\\media_url.]+)--/g, item.media_url)
        } else if(item.media_type == "VIDEO" && this.options.style == 'tile') {
          ItemTemplate = ItemTemplate.replace("insta-icon-carousel", "insta-icon-carousel hide")
          .replace("img", "img style='display: none'")
          .replace(/--([\s\\media_url.]+)--/g, item.media_url)
        } else if(item.media_type == "CAROUSEL_ALBUM") {
          ItemTemplate = ItemTemplate.replace("video", "video style='display: none'")
          .replace("insta-icon-video", "insta-icon-video hide")
          .replace(/--([\s\\media_url.]+)--/g, item.media_url)
        } else if(item.media_type == "IMAGE") { 
          ItemTemplate = ItemTemplate.replace("video", "video style='display: none'")
          .replace("insta-icon-video", "insta-icon-video hide")
          .replace("insta-icon-carousel", "insta-icon-carousel hide")
          .replace(/--([\s\\media_url.]+)--/g, item.media_url)
        }

        if(ItemTemplate.includes('insta-post-share')){
          const share = "open(this.href,'popup','width=600,height=600'); return false;"
          ItemTemplate = ItemTemplate.replace(/--([\s\\twitter_share.]+)--/g, share).replace(/--([\s\\facebook_share.]+)--/g, share);
        }

        return ItemTemplate;
      }

      instagram_request() {
        const self = this;
        try {
          const feed = new Instafeed({
            accountType: self.options.accountType,
            fields: self.options.fields,
            mock: true,
            success: function (data) {
              self.Instadata = data.data;
              self.refreshAccessToken(self.options.token_api);
              self.handleInstagramData(self.Instadata);
              window.on('resize', theme.utils.debounce(300, function () {
                self.handleInstagramData(self.Instadata);
              }));
            }
          });
          feed.run();
        } catch (e) {
          console.log(e)
        }
      }

      handleInstagramData(data) {
        this.limit = document.documentElement.clientWidth >= 781 ? (this.options.limit <= this.Instadata.length ? this.options.limit : this.Instadata.length) : (this.options.limitMob <= this.Instadata.length ? this.options.limitMob : this.Instadata.length);
        this.counter = Math.floor(this.Instadata.length / this.limit);
        this.remain = this.Instadata.length % this.limit;
        this.count = 0;

        if (this.count <= this.counter) {
          this.instagram_render(0, this.limit).then(() => {
            this.count += 1;

            if (this.loadMoreContainer) {
              this.loadMoreContainer.remove();
            }

            if (this.count < this.counter || (this.remain != 0 && this.counter == this.count)) {
              if (this.options.layout == 'grid') {
                this.instagram_loadmore();
              } else {
                const slideContainer = document.createElement('div');
                slideContainer.classList.add('swiper-slide', 'inline-flex');
                this.swiperWrapper.appendChild(slideContainer);
                this.instagram_slidemore();
              }
            } else {
              if (this.options.layout == 'slider') {
                this.InstaSlider = this.options.container.querySelector('.swiper').swiper;
              }
            }
          });
        }
      }

      async instagram_render(offset, limit) {
        const self = this;

        return new Promise(async function (resolve, reject) {
          let InnerTemplate = "";

          for (let i = offset; i < limit; i++) {
            const item = self.Instadata[i];
            const ItemTemplate = await self.replaceTemplateVariables(self.options.template, item);

            if(document.documentElement.clientWidth >= 781 || self.options.layout == 'grid'){
              InnerTemplate += ItemTemplate;
            } else {
              if(self.count == 0){
                const slideContainer = document.createElement('div');
                slideContainer.innerHTML = ItemTemplate;
                slideContainer.classList.add('swiper-slide', 'inline-flex');
                self.swiperWrapper.appendChild(slideContainer);
              } else {
                const slides = self.options.container.querySelectorAll('.swiper-slide');
                slides.forEach( (slide) => {
                  if(!slide.hasChildNodes()) {
                    slide.innerHTML = ItemTemplate;
                  }
                });
              }
            }
          }

          self.renderContainer(InnerTemplate);
          resolve();
        });
      }

      renderContainer(template) {
        if(this.options.layout == 'grid'){
          const gridContainer = document.createElement('div');
          gridContainer.innerHTML = template;
          gridContainer.classList.add('inline-flex');
          this.options.container.insertBefore(gridContainer, this.loadMoreContainer);
        } else if(document.documentElement.clientWidth >= 781){
          if(this.count == 0){
            const slideContainer = document.createElement('div');
            slideContainer.classList.add('swiper-slide', 'inline-flex');
            slideContainer.innerHTML = template;
            this.swiperWrapper.appendChild(slideContainer);
            const nextContainer = document.createElement('div');
            nextContainer.classist.add('swiper-slide', 'inline-flex');
            this.swiperWrapper.appendChild(nextContainer);
          } else {
            const slides = this.options.container.querySelectorAll('.swiper-slide');

            slides.forEach( (slide) => {
              if(!slide.hasChildNodes()) {
                slide.innerHTML = template;
              }
            });
          }
        }

        let videos = document.querySelectorAll('.insta-post-video');

        if (videos.length > 0) {
          videos.forEach((video) => {
            //video.play();
          })
        }

        let shareContainers = document.querySelectorAll('.insta-post-share');

        if (shareContainers.length > 0) {
          document.addEventListener('click', function (e) {
            if (e.target.classList.contains('insta-post-share') && !e.target.querySelector('.insta-post-share-popover').classList.contains('insta-post-share-popover-open')) {
              e.target.querySelector('.insta-post-share-popover').classList.add('insta-post-share-popover-open');
            } else {
              document.querySelectorAll('.insta-post-share-popover-open').forEach(share => { share.classList.remove('insta-post-share-popover-open') });
            }
          });
        }
      }

      instagram_loadmore() {
        const self = this;
        this.options.container.innerHTML += this.loadMore;
        const button = this.options.container.querySelector('.instafeed-loadmore .btn--small');

        button.addEventListener('click', function () {
          self.options.container.innerHTML += self.loader;
          const offset = self.limit * (self.count + 1) >= self.Instadata.length ? self.Instadata.length : self.limit * (self.count + 1);
          self.instagram_render(self.limit * self.count, offset);
          self.count += 1;

          self.options.container.querySelector('.instafeed-loadmore').remove();
          if (self.count <= self.counter || (self.count == self.counter && self.remain != 0)) {
            self.instagram_loadmore();
          }
        });
      }

      instagram_slidemore() {
        const self = this;
        this.options.swiperContainer.swiper.on('slideChange', function () {
          if (self.count < self.counter || (self.count == self.counter && self.remain != 0)) {
            const offset = self.limit * (self.count + 1) >= self.Instadata.length ? self.Instadata.length : self.limit * (self.count + 1);
            if (document.documentElement.clientWidth >= 781) {
              self.instagram_render(self.limit * self.count, offset);
              self.count += 1;
              if (self.count < self.counter || (self.count == self.counter && self.remain != 0)) {
                this.options.swiperContainer.swiper.appendSlide('<li class="swiper-slide inline-flex"></li>');
              }
            } else {
              const a = self.limit * self.count;
              for (a = (self.limit * self.count); a < offset; a++) {
                if (self.count != 1 || a != self.limit * self.count) {
                  this.options.swiperContainer.swiper.appendSlide('<li class="swiper-slide inline-flex"></li>');
                }
                self.instagram_render(a, a + 1);
              }
              self.count += 1;
            }
          }
        });
      }
    }
    customElements.define('social-feed', Feed);
  }

  } catch(e) { console.error(e); }
})();
})();
